import {
  useCallback,
  useEffect,
  useMemo,
  useState,
  type ReactNode,
} from "react";
import { SecondarySidebarContext } from "@/shared/ui/layout/secondarySidebarContext";

type SecondarySidebarProviderProps = {
  enabled: boolean;
  children: ReactNode;
};

export function SecondarySidebarProvider({
  enabled,
  children,
}: SecondarySidebarProviderProps) {
  const [content, setContentState] = useState<ReactNode>(null);

  const setContent = useCallback((nextContent: ReactNode) => {
    setContentState(nextContent);
  }, []);

  useEffect(() => {
    if (!enabled) {
      setContentState(null);
    }
  }, [enabled]);

  const value = useMemo(
    () => ({
      content: enabled ? content : null,
      setContent,
    }),
    [content, enabled, setContent],
  );

  return (
    <SecondarySidebarContext.Provider value={value}>
      {children}
    </SecondarySidebarContext.Provider>
  );
}
